import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import axios from '@/apiClient';
import getSettingsDeviceTransformer from '@/api/transformers/settings/device';
import getPosTransformer from '@/api/transformers/settings/posDevice';
import { AxiosResponse } from 'axios';

export default {
  fetchDevices() {
    return axios.get(
      '/device/list',
      {
        transformRequest: [
          ...getClientApiRequestTransformer,
          ...getSocketIdRequestTransformer,
        ],
        transformResponse: getSettingsDeviceTransformer(),
      },
    )
      .then(({ data }: AxiosResponse): Promise<any> => data);
  },
  fetchPos() {
    return axios.get(
      '/device/pos',
      {
        transformRequest: [
          ...getClientApiRequestTransformer,
          ...getSocketIdRequestTransformer,
        ],
        transformResponse: getPosTransformer(),
      },
    )
      .then(({ data }: AxiosResponse): Promise<any> => data);
  },
  createDeviceKassa(networkId: string) {
    return axios.post(
      `/device/titanA/create/${networkId}`,
      null,
      {
        transformRequest: [
          ...getClientApiRequestTransformer,
          ...getSocketIdRequestTransformer,
        ],
      },
    );
  },
  editDeviceKassa({ id, editedFields }: any) {
    return axios.patch(
      `/device/titanA/edit/${id}`,
      editedFields,
      {
        transformRequest: [
          ...getClientApiRequestTransformer,
          ...getSocketIdRequestTransformer,
        ],
      },
    );
  },
  removeNetwork(id: string) {
    return axios.delete(
      `/device/mikrotik/remove/${id}`,
      {
        transformRequest: [
          ...getClientApiRequestTransformer,
          ...getSocketIdRequestTransformer,
        ],
      },
    );
  },
  createPosDevice(data: { syncCode: string }) {
    return axios.post(
      '/device/pos/create',
      data,
      {
        transformRequest: [
          ...getClientApiRequestTransformer,
          ...getSocketIdRequestTransformer,
        ],
      },
    );
  },
  authorizePosDevice(data: { id: string; login: string; password: string }) {
    return axios.post(
      `/device/pos/authorize/${data.id}`,
      { login: data.login, password: data.password },
      {
        transformRequest: [
          ...getClientApiRequestTransformer,
          ...getSocketIdRequestTransformer,
        ],
      },
    );
  },
  removePosDevice(id: string) {
    return axios.delete(
      `/device/pos/remove/${id}`,
      {
        transformRequest: [
          ...getClientApiRequestTransformer,
          ...getSocketIdRequestTransformer,
        ],
      },
    );
  },
};
